import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = {
  type: "submit",
  form: "project-plan-template-editor-form",
  class: "btn btn-primary"
}

import { computed, toRef } from 'vue'
    import { EditorState } from "@common/Common"
    import type { ProjectPlanTemplateEditorViewModel } from "@Quest/ProjectPlanTemplates/Components/ProjectPlanTemplateEditor"

    // props
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectPlanTemplateEditor',
  props: {
    viewModel: {}
  },
  emits: ["create-template", "update-template"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    // emits
    const emit = __emit

    // vm shortcut
    const vm = toRef(props, 'viewModel')

    // state
    const opened = computed(() => vm.value?.opened ?? false)

    const confirmButtonLabel = computed(() =>
        vm.value.state === EditorState.Creator ? 'Create' : 'Update'
    )

    const modalTitle = computed(() =>
        vm.value.state === EditorState.Creator
            ? 'New business case template'
            : 'Edit the business case template'
    )

    // actions
    function onFormSubmit()
    {
        if (vm.value.state === EditorState.Creator)
        {
            emit('create-template', vm.value.data)
        }
        else if (vm.value.state === EditorState.Editor)
        {
            emit('update-template', vm.value.data)
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "project-plan-template-editor-form",
                  onSubmit: _withModifiers(onFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "Name", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.data.Name) = $event)),
                      class: "form-control",
                      required: "",
                      minlength: "2",
                      maxlength: "100"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        vm.value.data.Name,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.value.data.Description) = $event)),
                      class: "form-control",
                      maxlength: "250"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        vm.value.data.Description,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { for: "account" }, "Granularity", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      id: "account",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vm.value.data.Granularity) = $event)),
                      class: "form-control"
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("option", { value: "Monthly" }, "Monthly", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Quarterly" }, "Quarterly", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Yearly" }, "Yearly", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, vm.value.data.Granularity]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { for: "denomination" }, "Currency denomination", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      id: "denomination",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((vm.value.data.Denomination) = $event)),
                      class: "form-control"
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("option", { value: "Unit" }, "Unit", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Thousand" }, "Thousand", -1 /* CACHED */),
                      _createElementVNode("option", { value: "Million" }, "Million", -1 /* CACHED */)
                    ]))], 512 /* NEED_PATCH */), [
                      [_vModelSelect, vm.value.data.Denomination]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", null, "Project execution (in months)", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((vm.value.data.DurationInMonths) = $event)),
                      class: "form-control",
                      required: "",
                      min: "1",
                      step: "1"
                    }, null, 512 /* NEED_PATCH */), [
                      [
                        _vModelText,
                        vm.value.data.DurationInMonths,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", _hoisted_14, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})